var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{attrs:{"border-variant":"white"}},[_c('b-button',{staticClass:"ml-5",attrs:{"size":"lg","variant":"danger"},on:{"click":function($event){return _vm.signout()}}},[_c('b-icon-box-arrow-left',{staticClass:"mr-2"}),_c('b',[_vm._v("Logout")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }